import type { Config } from "@apptus/esales-api";
import { elevate } from "@apptus/esales-api";
import { getCookie } from "cookies-next";

import { env } from "@/env";
import type { MarketConfiguration } from "@/config/markets/const";
import { CUSTOMER_KEY_COOKIE, SESSION_KEY_COOKIE } from "@/config/voyado";
import { uuidv4 } from "@/utils/uuidv4";

import detectDevice from "./requests/elevate/detectDevice";

function elevateClient(market: MarketConfiguration) {
  const config: Config = {
    clusterId: env.NEXT_PUBLIC_ELEVATE_CLUSTER_ID,
    market: market.elevateMarket,
    locale: market.contentfulLocale,
    touchpoint: "desktop",
    session: () => ({
      customerKey: uuidv4(),
      sessionKey: uuidv4(),
    }),
  };

  if (typeof window !== "undefined") {
    Object.assign(config, {
      touchpoint: detectDevice(),
      session: () => {
        const customerKey = getCookie(CUSTOMER_KEY_COOKIE);
        const sessionKey = getCookie(SESSION_KEY_COOKIE);

        return {
          customerKey: typeof customerKey === "string" ? customerKey : uuidv4(),
          sessionKey: typeof sessionKey === "string" ? sessionKey : uuidv4(),
        };
      },
    });
  }

  return elevate(config);
}

export default elevateClient;
